import { render, staticRenderFns } from "./ArticleOrderAdmin.vue?vue&type=template&id=42b78340&scoped=true"
import script from "./ArticleOrderAdmin.vue?vue&type=script&lang=js"
export * from "./ArticleOrderAdmin.vue?vue&type=script&lang=js"
import style0 from "./ArticleOrderAdmin.vue?vue&type=style&index=0&id=42b78340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b78340",
  null
  
)

export default component.exports